// extracted by mini-css-extract-plugin
export default {"root":"Button_root__vswH3","active":"Button_active__iTrrO"};